import React from 'react';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMRestClient from 'lib/SMRestClient';

class SMFeatureListView extends React.Component {
  
  render() {
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="page-xs12-head">
              <h1 className="page-title">{I18n.t('service.label_000105')}</h1>
              <p className="page-description">スペースマーケットに掲載されているユニークなレンタルスペースを、用途や時々のイベントごとにまとめました。<br />気になるまとめが見つかったらページから簡単に友達へシェア。検索とは違った切り口でのレンタルスペース探しに活用ください。</p>
            </div>
            <div className="row">
            {(()=>{
              return this.props.features.map((feature, index) => {
                return(
                  <div key={feature.id} className="col-sm-12 col-md-4 matome-box">
                    <a href={Routes.feature_path(feature.uid)}>
                      <div className="matome-linkbox">
                        <img src={feature.image} alt={feature.title} className="is-hover" />
                        <h2 className="matome-subtitle">{feature.title}</h2>
                      </div>
                    </a>
                    <p className="js-line-camp-2 matome-description">{feature.description}</p>
                  </div>
                );
              });
            })()}
            </div>
            <SMSearchPagerView 
              delegate={this}
              totalCount={this.props.totalCount}
              perPage={this.props.perPage}
              currentPage={this.props.currentPage}
              options={{className: "search-list__main-nav ta-c"}}
              links={SMRestClient.parseLinkString(this.props.linkString)} />
          </div>
        </div>
      </div>
    );
  }
}
export default SMFeatureListView;



// WEBPACK FOOTER //
// ./app/javascript/components/features/SMFeatureListView.jsx